import { Mic, Printer } from 'lucide-react';
import type { NavigationItem } from '@/shared/types/navigation';

export const mediaNavItems: NavigationItem[] = [
  {
    id: 'voices',
    category: 'tool',
    name: 'voices.nav.name',
    description: 'voices.nav.description',
    icon: Mic,
    href: '/voices',
  },
  {
    id: 'printing',
    category: 'tool',
    name: 'printing.nav.name',
    description: 'printing.nav.description',
    icon: Printer,
    href: '/print',
  },
];
